import { Helpers } from '../utilities/helpers';

const vehicleImageHelpers = {
  setStockImage: async function(url = ''){
      await Helpers.setInStorage('vehicle-image', url)
      this.setState({
        vehicleImageUrl: url
      })
  },
  getStockImage: async function(){
    const { vehicleImageUrl } = this.state
    const vehicleStockImage = await Helpers.getInStorage('vehicle-image')

    if (vehicleStockImage !== vehicleImageUrl){
      this.setState({
        vehicleImageUrl: vehicleStockImage
      })
    }
  }
}

export { vehicleImageHelpers }